export default (timeSlot = 30) => {
  const defaultTimeSlot = timeSlot; // default 30 minutes interval
  const times = []; // time array
  let startTime = 540; // start time 9:00am
  let startApp;
  let endApp;
  //loop to increment the time and push results in array
  for (let i = 0; startTime < 18.5 * 60; i += 1) {
    const hhs = Math.floor(startTime / 60); // getting hours of day in 0-24 format
    const mms = startTime % 60; // getting minutes of the hour in 0-55 format
    startApp = `${`0${hhs}`.slice(-2)}:${`0${mms}`.slice(-2)}`;
    startTime += defaultTimeSlot; // increment 30 minutes
    const hhe = Math.floor(startTime / 60); // getting hours of day in 0-24 format
    const mme = startTime % 60; // getting minutes of the hour in 0-55 format
    endApp = `${`0${hhe}`.slice(-2)}:${`0${mme}`.slice(-2)}`;
    times[i] = `${startApp} - ${endApp}`;
  }
  return times;
};
